<template>
  <div class="footer">

    <v-footer color="#221F1F">
      <v-container fluid>
        <v-row>
          <v-col cols="12" md="auto" class="pr-12 footer-first-column pl-0">
            <router-link to="/custom">
              <v-img src="@/assets/img/icons/logo-custom-vertical.svg" class="footer-logo-artless d-none d-md-flex" max-width="100px"></v-img>

              <v-img src="@/assets/img/icons/custom-logo-white.svg" class="footer-logo-artless d-md-none" max-width="100px"></v-img>
            </router-link>
          </v-col>
          <v-col cols="4" md="auto" class="pr-12">
            <div>
              <router-link to="/custom/about" class="not-text-decoration footer-links ">
                <span class="white--text gtAmerica-extended">About</span>
              </router-link>
            </div>
            <div>
              <router-link to="/manifesto" class="not-text-decoration footer-links">
                <span class="white--text gtAmerica-extended">Manifesto</span>
              </router-link>
            </div>
            <div>
              <router-link to="/materials" class="not-text-decoration footer-links">
                <span class="white--text gtAmerica-extended">Materials</span>
              </router-link>
            </div>
            <!-- <div>
              <router-link to="/mosaic" class="not-text-decoration footer-links">
                <span class="white--text gtAmerica-extended">Mosaic</span>
              </router-link>
            </div> -->
          </v-col>
          <v-col cols="4" md="auto" class="pr-12">
              <div>
                <router-link to="/custom/contact/dealers" class="not-text-decoration footer-links">
                  <span class="white--text gtAmerica-extended">Find a Dealer</span>
                </router-link>
              </div>
              <div>
                <router-link to="/terms" class="not-text-decoration footer-links">
                  <span class="white--text gtAmerica-extended">Terms of Service</span>
                </router-link>
              </div>
              <div>
                <router-link to="/faq" class="not-text-decoration footer-links">
                  <span class="white--text gtAmerica-extended">FAQ</span>
                </router-link>
              </div>
          </v-col>
          <v-col cols="4" md="auto">
            <div>
              <router-link to="/custom/contact" class="not-text-decoration footer-links">
                <span class="white--text gtAmerica-extended">Contact</span>
              </router-link>
            </div>
            <div>
              <a href="https://www.instagram.com/artlesscustom/" class="not-text-decoration footer-links" target="_blank">
                <span class="white--text gtAmerica-extended">Instagram</span>
              </a>
            </div>
          </v-col>
          <v-col class="py-0 footer-last-column">
            <div class="text-right">
              <span class="white--text d-block newsletter-title">NEWSLETTER</span>
            </div>
            <v-row class="margin-custom-textfield mt-0" justify="end">
              <v-col cols="auto" class="py-0">
                <mailchimp-subscribe
                  url="https://artlesscorporation.us11.list-manage.com/subscribe/post-json"
                  user-id="158bad0f97861eb45fb3c0463"
                  list-id="d9232776f5"
                  @error="onError"
                  @success="onSuccess"
                >
                  <template v-slot="{ subscribe, setEmail, error, success, loading }">
                    <form @submit.prevent="subscribe">
                      <!-- <v-text-field
                        v-model="emailNewsLetter"
                        label="ENTER YOUR EMAIL"
                        outlined
                        flat
                        background-color="#221F1F"
                        dark
                        :placeholder="newsletter.newsletterText"
                        elevation="0"
                        hide-details
                        name="EMAIL"
                        append-icon="mdi-send-circle"
                        @input="setEmail($event.target.value)"
                      ></v-text-field> -->
                      <fieldset class="white--text px-2 py-2" style="border-color: rgba(255, 255, 255, 0.7); border-radius: 5px;">
                        <legend class="GTAmerica" style="font-size: 12px; color: rgba(255, 255, 255, 0.7)">ENTER YOUR EMAIL</legend>
                        <input v-model="emailNewsLetter" type="email" @input="setEmail($event.target.value)" class="white--text mr-5 d-inline-block" :placeholder="newsletter.newsletterText" style="outline: none; min-width: 290px" />
                        <button type="submit" style="outline: none;">
                          <v-icon color="white">mdi-send-circle</v-icon>
                        </button>
                      </fieldset>
                      <!-- <div class="white--text" v-if="error">{{ error }}</div>
                      <div class="white--text" v-if="success">Yay!</div>
                      <div class="white--text" v-if="loading">Loading…</div> -->
                    </form>
                  </template>
                </mailchimp-subscribe>
                <!-- <form
                  action="https://artlesscorporation.us11.list-manage.com/subscribe/post?u=158bad0f97861eb45fb3c0463&amp;id=d9232776f5"
                  method="post"
                  id="mc-embedded-subscribe-form"
                  name="mc-embedded-subscribe-form"
                  class="validate"
                  target="_blank"
                  novalidate
                >
                  <v-text-field
                    v-model="emailNewsLetter"
                    label="ENTER YOUR EMAIL"
                    outlined
                    flat
                    background-color="#221F1F"
                    dark
                    :placeholder="newsletter.newsletterText"
                    elevation="0"
                    hide-details
                    name="EMAIL"
                    append-icon="mdi-send-circle"
                    @click:append="sendNewsletter()"
                  ></v-text-field>
                </form> -->
                <!-- <v-text-field
                  v-model="emailNewsLetter"
                  label="ENTER YOUR EMAIL"
                  outlined
                  flat
                  background-color="#221F1F"
                  dark
                  :placeholder="newsletter.newsletterText"
                  elevation="0"
                  hide-details
                ></v-text-field> -->
                <div class="text-right py-4">
                  <span class="white--text copyright-leg">©️ 2008-2024 ARTLESS CORPORATION. ALL RIGHTS RESERVED.</span>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
    <v-snackbar top v-model="snackbar" color="#221f1f">
      <span class="white--text text-center">
        THANK <span class="bold white--text">YOU!</span>
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import MailchimpSubscribe from 'vue-mailchimp-subscribe'
export default {
  name: "Footer",
  components:{
    MailchimpSubscribe
  },
  props: {
    menu: { type: Number, required: true },
  },
  data() {
    return {
      snackbar: false,
      emailNewsLetter: "",
      newsletter: {
        newsletterText: ''
      },
      links: [
        {
          rutas1: [
            {
              url: "/furniture",
              text: "Furniture",
            },
            {
              url: "/custom",
              text: "Custom",
            },
            {
              url: "/shop",
              text: "Shop",
            },
          ],
          rutas2: [
            {
              url: "/materials",
              text: "Materials",
            },
            {
              url: "/about",
              text: "About",
            },
            {
              url: "/contact",
              text: "Contact",
            },
          ],
          rutas3: [
            {
              url: "https://www.instagram.com",
              text: "Instagram",
            },
            {
              url: "/terms",
              text: "Terms of services",
            },
            {
              url: "/terms",
              text: "Terms of services",
            },
            {
              url: "/faq",
              text: "FAQ",
            },
          ],
        },
      ],
    };
  },
  beforeMount: function(){
    fetch('https://www.artlesscms.actstudio.xyz/api/singletons/get/Newsletter?token=a15be93e9cdb43ca2b3778c2077c26')
    .then(data => data.json())
    .then(data => this.newsletter = data);
  },
  methods: {
    sendNewsletter: function(){
      document.getElementById("mc-embedded-subscribe-form").submit();

      //mc-embedded-subscribe-form
    },
    onError() {
      // this.snackbar = true;
      // handle error
    },
    onSuccess() {
      this.emailNewsLetter = '';
      this.snackbar = true;
      // handle success
    },
    submit: function(){
      this.$refs.subscribemailchimp.submit()
    }
  }
};
</script>